import { render, staticRenderFns } from "./No23.vue?vue&type=template&id=373a70d4&scoped=true"
import script from "./No23.vue?vue&type=script&lang=js"
export * from "./No23.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373a70d4",
  null
  
)

export default component.exports